<template>
  <div v-if="featureStore.featurePoolMirrorCampaign">
    <HeaderNavbar
      :title="$t('nav.cvanalyzer')"
      :breadcrumbs="[{ label: $t('cvanalyzer.list.title'), path: { name: 'cvanalyzer.list' } }]">
      <template #right-side>
        <HeaderNavbarSearch :model-value="searchQuery"></HeaderNavbarSearch>
      </template>
    </HeaderNavbar>
    <div class="container-lead"></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { useCustomerFeaturesStore } from '@/stores/customerFeatures';
import HeaderNavbar from '@/components/header/HeaderNavbar.vue';
import HeaderNavbarSearch from '@/components/header/HeaderNavbarSearch.vue';

const featureStore = useCustomerFeaturesStore();

const searchQuery = ref('');
</script>

<style></style>
